import _implicitStylesheets from "./app.css";

import _implicitScopedStylesheets from "./app.scoped.css?scoped=true";

import _zpaperLoginView from "zpaper/loginView";
import _zpaperPageButtons from "zpaper/pageButtons";
import _zpaperPdfViewer from "zpaper/pdfViewer";
import _zpaperPdfViewerToolbar from "zpaper/pdfViewerToolbar";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {h: api_element, c: api_custom_element, gid: api_scoped_id} = $api;
  return [api_element("header", {
    key: 0
  }, []), api_element("main", {
    classMap: {
      "content": true
    },
    styleDecls: [["position", "fixed", false]],
    key: 1
  }, [!$cmp.isLoggedIn ? api_custom_element("zpaper-login-view", _zpaperLoginView, {
    key: 2
  }, []) : null, $cmp.isLoggedIn ? $cmp.displayMobileToolbar ? api_element("div", {
    classMap: {
      "row": true
    },
    key: 3
  }, [api_element("div", {
    classMap: {
      "bottombarPanel": true
    },
    key: 4
  }, [api_custom_element("zpaper-page-buttons", _zpaperPageButtons, {
    props: {
      "hideSearch": $cmp.hideSearchBar
    },
    key: 5
  }, [])])]) : null : null, $cmp.isLoggedIn ? api_element("div", {
    classMap: {
      "row": true
    },
    key: 6
  }, [api_element("div", {
    classMap: {
      "column": true,
      "side": true,
      "left": true
    },
    styleDecls: [["display", "none", false], ["height", "100vh", false], ["overflow-y", "auto", false], ["min-width", "525px", false]],
    attrs: {
      "id": api_scoped_id("colum")
    },
    key: 7
  }, [api_element("div", {
    classMap: {
      "leftColumnBody": true
    },
    key: 8
  }, [])]), api_element("div", {
    classMap: {
      "column": true,
      "middle": true
    },
    key: 9
  }, [api_custom_element("zpaper-pdf-viewer", _zpaperPdfViewer, {
    props: {
      "parentLoadsPdf": $cmp.parentLoadsPdf,
      "tParam": $cmp.tParam
    },
    key: 10
  }, [])]), api_element("div", {
    classMap: {
      "column": true,
      "side": true,
      "right": true
    },
    styleDecls: [["display", "none", false]],
    key: 11
  }, [api_element("div", {
    classMap: {
      "rightColumnBody": true
    },
    key: 12
  }, [])])]) : null, $cmp.isLoggedIn ? $cmp.displayMobileToolbar ? $cmp.displayMobileToolbar ? api_element("div", {
    classMap: {
      "row": true
    },
    key: 13
  }, [api_element("div", {
    classMap: {
      "bottombarPanel": true
    },
    key: 14
  }, [api_custom_element("zpaper-pdf-viewer-toolbar", _zpaperPdfViewerToolbar, {
    key: 15
  }, [])])]) : null : null : null])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-app_app"
